import { motion } from "framer-motion";
import { Play } from "@phosphor-icons/react";

const ABOUT_IMG = "https://www.laser-machines.com/images/about_img.webp";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="bg-white">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 py-16 sm:px-8 lg:grid-cols-2 lg:gap-16 lg:py-20">
        <motion.a
          href="https://www.laser-machines.com/company-profile.html"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="about-video-link"
          initial={{ opacity: 0, x: -24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="group relative block overflow-hidden"
        >
          <img src={ABOUT_IMG} alt="Penta Laser manufacturing facility" className="h-full min-h-[320px] w-full object-cover transition-transform duration-300 group-hover:scale-105" />
          <span className="absolute inset-0 flex items-center justify-center">
            <span className="flex h-20 w-20 items-center justify-center rounded-full bg-laser/90 text-white shadow-lg transition-transform duration-200 group-hover:scale-110">
              <Play size={30} weight="fill" />
            </span>
          </span>
        </motion.a>
        <motion.div
          initial={{ opacity: 0, x: 24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <h2 className="text-3xl font-bold text-[#222] sm:text-4xl" data-testid="about-heading">About PENTA LASER</h2>
          <p className="mt-2 text-lg font-medium text-[#444]">Laser Machinery Manufacturer</p>
          <p className="mt-5 text-sm leading-relaxed text-muted-foreground">
            Committed to environmental sustainability, we offer an extensive product lineup that includes large-scale laser cutters, pipe cutters, 3D gantry lasers, and welding equipment, in addition to key components like control systems and welding heads. Driven by principles of innovation, independence, and environmental consciousness, we are dedicated to advancing high-quality technology.
          </p>
          <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
            Our focus on high-power laser technology has attracted a strong R&D team of over 200 professionals, including more than 20 international experts. Operating three manufacturing sites in China and one in Italy, Penta Laser achieved a sales contract value exceeding 2.5 billion yuan in 2021, solidifying its leadership in the high-power laser industry.
          </p>
          <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
            Pentalaser Australia brings this technology to local fabricators with sales, installation and service from our Hallam, Victoria office - so your machine keeps cutting, not waiting.
          </p>
          <a
            href="#contact"
            data-testid="about-more-btn"
            className="mt-7 inline-block border border-[#999] px-8 py-3 text-sm font-medium text-[#333] transition-colors duration-150 hover:border-laser hover:text-laser"
          >
            View More
          </a>
        </motion.div>
      </div>
    </section>
  );
}
